/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_DescriptionInputs */



/**
* | output |
* | --- |
* | "Contact AWP Marine Consultancy for vessel inspections, vetting and marine consultancy, by phone, email or the enquiry form." |
*
* @param {Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_description = /** @type {((inputs?: Contact_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("通过电话、邮件或咨询表单联系 AWP Marine Consultancy，咨询船舶检查、审查和海事咨询服务。")
	return /** @type {LocalizedString} */ ("Contact AWP Marine Consultancy for vessel inspections, vetting and marine consultancy, by phone, email or the enquiry form.")
});